<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <div>
        <el-input
          clearable
          v-model.trim="searchCondition.receiverMobile"
          placeholder="请输入手机号"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          v-model.trim="searchCondition.taskName"
          placeholder="请输入任务名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-select
          clearable
          v-model="searchCondition.sendState"
          placeholder="请选择发送状态"
          filterable
          size="small"
          class="mr10"
        >
          <el-option label="全部状态" value=""></el-option>
          <el-option label="发送成功" value="0"></el-option>
          <el-option label="发送失败" value="1"></el-option>
        </el-select>
        <el-date-picker
          v-model="searchCondition.applyDate"
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          align="right"
          start-placeholder="请选择时间段"
          end-placeholder="请选择时间段"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output('queryAllList', '短信发送记录')"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div>
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="发送时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createBy"
          label="发送人"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="taskName"
          label="任务名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="smsContent"
          label="发送内容"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiverMobile"
          label="接收人"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sendState"
          label="发送状态"
        >
          <template slot-scope="scope">
            <div :class="scope.row.sendState === '0' ? 'success' : 'danger'">
              {{ scope.row.sendState === "0" ? "发送成功" : "发送失败" }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isOutputing: false,
      searchCondition: {
        applyDate: []
      },
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    let nowDate = new Date();
    let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      date: nowDate.getDate()
    };
    if (date.month >= 1 && date.month <= 9) {
      date.month = "0" + date.month;
    }
    if (date.date >= 0 && date.date <= 9) {
      date.date = "0" + date.date;
    }
    let systemDate = date.year + "-" + date.month + "-" + date.date;

    this.searchCondition.applyDate = [
      `${systemDate} 00:00:00`,
      `${systemDate} 23:59:59`
    ];
    this.queryList();
  },
  methods: {
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    // async queryAllList() {
    //   let params = {
    //     pageSize: 99999,
    //     pageNo: 1
    //   };
    //   const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
    //   searchCondition.createTimeStart = this.isArray(searchCondition.applyDate)
    //     ? searchCondition.applyDate[0]
    //     : "";
    //   searchCondition.createTimeEnd = this.isArray(searchCondition.applyDate)
    //     ? searchCondition.applyDate[1]
    //     : "";
    //   Object.assign(params, searchCondition);
    //      const { result } = await this.$store.dispatch("queryAllStoreSmsSendRecordList", params);

    // },
    async queryList(queryAll) {
      let params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: queryAll ? 1 : this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.createTimeStart = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.createTimeEnd = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[1]
        : "";
      Object.assign(params, searchCondition);
      let name = queryAll
        ? "queryAllStoreSmsSendRecordList"
        : "queryStoreSmsSendRecordList";
      const { result } = await this.$store.dispatch(name, params);
      const { records, total } = result;
      if (!queryAll) {
        this.list = records;
        this.total = total;
      } else {
        return records;
      }
    },
    // 导出excel
    output(funcName, title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryList(funcName)
          .then(res => {
            const list = res;
            list.forEach(v => {
              if (v.sendState === "0") {
                v.sendState = "发送成功";
              } else {
                v.sendState = "发送失败";
              }
            });
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped></style>
